export default "__VITE_ASSET__C5gMGfX7__"